enum LoadingPageTitle {
    MBTI = "Your MBTI personality type is",
    STARSIGN = "You are a",
    LOVELANGUAGE = "Your top 3 love languages are",
    DEFAULT = "You are a",
}

export {LoadingPageTitle}